<template>
  <button class="menu-item-favorite" aria-label="Add to favorite" @click.stop.prevent="updateFavorite">
    <label for="menu-item-favorite" class="iw-visuallyhidden">Add to favorite</label>
    <svg
      :class="{
        'menu-item-favorite__favorite': isFavorite(menuItem.id) && visitorId
      }"
      class="menu-item-favorite__svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 107 92"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="8"
        d="M57.8 10.594l-4.766 4.783-4.839-4.857C43.03 5.354 36.246 2.784 29.469 2.784c-6.776 0-13.56 2.57-18.726 7.736C.413 20.85.425 37.662 10.743 48l39.723 39.8c1.322 1.31 3.705 1.31 5.026 0C68.744 74.549 81.999 61.328 95.25 48.076c10.332-10.332 10.332-27.15 0-37.482-10.33-10.332-27.12-10.332-37.45 0z"
      />
    </svg>
  </button>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LoginModal from "@/components/modal/login-modal/LoginModal";
import { MIN_DESKTOP_WIDTH } from "@/utils";

export default {
  name: "MenuItemFavorite",
  props: {
    menuItem: Object
  },
  methods: {
    ...mapActions("user", ["updateFavorites"]),
    ...mapActions("messages", ["addMessage"]),
    updateFavorite() {
      if (this.visitorId) {
        this.updateFavorites(this.menuItem.id);
      } else {
        this.openLoginModal();
      }
    },
    openLoginModal() {
      this.$modal.show(
        LoginModal,
        { headerMessage: "Please login to access your favorites" },
        window.innerWidth > MIN_DESKTOP_WIDTH
          ? {
              name: "login",
              height: "92%",
              width: "75%",
              adaptive: true,
              scrollable: true
            }
          : {
              name: "login",
              height: "100%",
              width: "100%",
              adaptive: true,
              scrollable: true
            }
      );
    }
  },
  computed: {
    ...mapGetters({
      isFavorite: "user/isFavorite",
      visitorId: "user/getVisitorId"
    })
  }
};
</script>

<style lang="scss">
.menu-item-fav-notifier {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  border: solid 1px #e3e3e3;
  border-radius: 28px;
}
</style>

<style scoped lang="scss">
.menu-item-favorite {
  cursor: pointer;
  position: absolute;
  display: flex;

  justify-content: center;
  align-items: center;
  text-align: center;

  width: 28px;
  height: 28px;

  border-radius: 30px;
  box-sizing: border-box;
  border: solid 1px rgba(151, 151, 151, 0.2);
  background-color: rgba(255, 255, 255, 0.75);
  right: 6px;
  top: 72px;

  &__svg {
    padding-top: 2px;
    width: 14px;
    fill: transparent;
    stroke: $group-3-color-3;
  }

  &__favorite {
    stroke: transparent;
    fill: $group-4-color-1;
  }
}
</style>
